// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "f84b476995a8496adce24ec672244eafc9a43686/" + chunkId + ".js";
};